import { css } from "emotion";
import P from "../../../components/global/P";
import H2 from "../../../components/global/H2";
import SplitContent from "../../../components/layout/SplitContent";

const wrapper = css({
  maxWidth: 1200,
  padding: "74px 75px 72px 120px",
  margin: "0 auto",
  "@media(max-width: 580px)": {
    padding: "74px 14px 0px 14px"
  },
  "@media(max-width: 550px)": {
    paddingTop: 36,
    paddingBottom: 36
  }
});

const textColumn = css({
  width: 421,
  display: "inline-block",
  marginRight: 84,
  "@media(max-width: 550px)": {
    marginRight: 0,
    width: "100%"
  }
});

const imageStyle = css({
  display: "inline-block",
  width: 418,
  height: 340,
  marginBottom: 91,
  "@media(max-width: 1199px)": {
    display: "none"
  }
});

const featureImage = require("../../../assets/image_brainstorm.png");

const History = ({}) => {
  return (
    <div id="cofounders">
      <SplitContent image={featureImage}>
        <H2 marginBottom={16} marginBottomMobile={16}>
          How it all started
        </H2>
        <P marginBottom={12} marginBottomMobile={8}>
          Josh and Adam have been best friends for over a decade. They have
          volunteered for a range of organisations, sharing a passion for
          health, environment, education and indigenous affairs. Together, they
          recognise the exciting potential for technological disruption to play
          a role in philanthropy.
        </P>
        <P marginBottom={12} marginBottomMobile={8}>
          After volunteering two years of their time to get Humanitix off the
          ground, there is now a broad team working with Humanitix, with
          considerable support from some of Australia’s largest philanthropists.
        </P>
        <P marginBottom={12} marginBottomMobile={8}>
          From here on the sky is the limit. The events ticketing industry
          generates billions in fees! Imagine if we converted the booking fees
          into ongoing sustainable funding for the causes we all care about.
        </P>
        <P semiBold>
          Our goal is to provide a better service, at a better price, whilst
          donating profits to charity.
        </P>
      </SplitContent>
    </div>
  );
};

export default History;
